import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import { useInvalidateCarriersQuery } from "./use-carriers-query";
import useInvalidateShop from "./use-invalidate-shop";

export function useDeleteCarrierPricing(shopId: string) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shopId);
	const invalidateWorkflowListQuery = useInvalidateCarriersQuery({ shopId });

	const mutation = $api.useMutation(
		"delete",
		"/shops/{shopId}/carriers/{carrierId}/pricings/{carrierPricingId}",
	);

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			invalidateWorkflowListQuery();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async ({
			carrierId,
			carrierPricingId,
		}: {
			carrierId: string;
			carrierPricingId: string;
		}) => {
			return mutation.mutateAsync({
				params: { path: { carrierId, carrierPricingId, shopId } },
			});
		},
	});
}
